<template>
  <div>
    <v-flex v-if="simc && showSelect" xs12>
      <v-autocomplete
        id="street"
        v-model="selectedULIC"
        clearable
        outlined
        hide-no-data
        placeholder="Wpisz nazwę ulicy"
        item-text="nameFull"
        item-value="symbol"
        :disabled="disabled"
        :items="streets"
        :search-input.sync="search"
        :label="label"
        :error-messages="model.street.$error"
        @focus="focus('street')"
        @blur="blur('street')"
        @change="changeStreet"
      />
      <div class="text-body-2 grey--text text--darken-2 mt-n2 mb-4" style="line-height: 1.5">
        <div class="font-weight-bold mb-1">Informacja dotycząca adresów z części miejscowości Przewłoka</div>
        <div>
          Od 1 stycznia 2026 r. do Miasta Ustka zostanie włączona część miejscowości Przewłoka. Do tego czasu pole
          „Miejscowość” pozostaje ustawione na Ustka, natomiast ulice z włączanej części Przewłoki są dostępne w wykazie
          ulic z dopiskiem „(Przewłoka)”.
        </div>
        <div class="mt-1">
          Po wejściu zmian w życie adresy zostaną zaktualizowane automatycznie – bez konieczności podejmowania
          jakichkolwiek działań przez użytkowników.
        </div>
      </div>
    </v-flex>
  </div>
</template>

<script>
import axios from 'axios';

import { notificationsMixin } from '@/mixins/notifications';

const ULIC_OVERRIDE = [
  { symbol: '90001', nameFull: 'ul. 45-lecia Gminy Ustka (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90002', nameFull: 'ul. Armii Krajowej (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90003', nameFull: 'ul. Adama Asnyka (Przewłoka)', terc: '2212102', applyTo: '221201' },
  {
    symbol: '90004',
    nameFull: 'ul. Krzysztofa Kamila Baczyńskiego (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  },
  { symbol: '90005', nameFull: 'ul. J. Brzechwy (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90006', nameFull: 'ul. Brzozowa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90007', nameFull: 'ul. Bukowa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90008', nameFull: 'ul. Cyprysowa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90009', nameFull: 'ul. M. Dąbrowskiej (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90010', nameFull: 'ul. J. Długosza (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90011', nameFull: 'ul. A. Fredry (Przewłoka)', terc: '2212102', applyTo: '221201' },
  {
    symbol: '90012',
    nameFull: 'ul. Konstantego Ildefonsa Gałczyńskiego (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  },
  { symbol: '90013', nameFull: 'ul. Witolda Gombrowicza (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90014', nameFull: 'ul. Grabowa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90015', nameFull: 'ul. Zb. Herberta (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90016', nameFull: 'ul. Marka Hłaski (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90017', nameFull: 'ul. Pawła Jasienicy (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90018', nameFull: 'ul. Michała Kajki (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90019', nameFull: 'ul. J. Kasprowicza (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90020', nameFull: 'ul. Kasztanowa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90021', nameFull: 'ul. Klonowa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90022', nameFull: 'ul. Jana Kochanowskiego (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90023', nameFull: 'ul. F. Konarskiego (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90024', nameFull: 'ul. M. Konopnickiej (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90025', nameFull: 'ul. St. Lema (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90026', nameFull: 'ul. Bolesława Leśmiana (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90027', nameFull: 'ul. Czesława Miłosza (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90028', nameFull: 'ul. A. F. Modrzewskiego (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90029', nameFull: 'ul. Morska (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90030', nameFull: 'ul. Z. Nałkowskiej (Przewłoka)', terc: '2212102', applyTo: '221201' },
  {
    symbol: '90031',
    nameFull: 'ul. Juliana Ursyna Niemcewicza (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  },
  {
    symbol: '90032',
    nameFull: 'ul. Cypriana Kamila Norwida (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  },
  { symbol: '90033', nameFull: 'ul. E. Orzeszkowej (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90034', nameFull: 'ul. Agnieszki Osieckiej (Przewłoka)', terc: '2212102', applyTo: '221201' },
  {
    symbol: '90035',
    nameFull: 'ul. im. płk. Witolda Pileckiego (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  },
  { symbol: '90036', nameFull: 'ul. B. Prusa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  {
    symbol: '90037',
    nameFull: 'ul. Kazimierza Przerwy-Tetmajera (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  },
  {
    symbol: '90038',
    nameFull: 'rondo Rondo im. Danuty Siedzikówny ps. "INKA" (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  },
  {
    symbol: '90039',
    nameFull: 'rondo Rondo im. Pawła Panasiuka (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  },
  {
    symbol: '90040',
    nameFull: 'ul. im. Generała Stefana Roweckiego "Grota" (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  },
  { symbol: '90041', nameFull: 'ul. Juliusza Słowackiego (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90042', nameFull: 'ul. Leopolda Staffa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90043', nameFull: 'ul. Wisławy Szymborskiej (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90044', nameFull: 'ul. Topolowa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90045', nameFull: 'ul. Juliana Tuwima (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90046', nameFull: 'ul. Ustecka (Przewłoka)', terc: '2212102', applyTo: '221201' },
  { symbol: '90047', nameFull: 'ul. Uzdrowiskowa (Przewłoka)', terc: '2212102', applyTo: '221201' },
  {
    symbol: '90048',
    nameFull: 'ul. Stanisława Wyspiańskiego (Przewłoka)',
    terc: '2212102',
    applyTo: '221201'
  }
];

// @vuese
// Input na ULIC-a
// @group Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Nazwa pola z ULIC-em
    field: {
      type: String,
      required: false,
      default: 'ulic'
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    },
    // Wartość SIMC-a
    simc: {
      type: String,
      required: true
    },
    // Nazwa miasta
    city: {
      type: String,
      required: false
    },
    // Czy pola mają być disabled
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      streets: [],
      search: '',
      selectedULIC: undefined,
      showSelect: false,
      label: this.model.street.$schema.fieldRequired ? 'Ulica *' : 'Ulica'
    };
  },
  watch: {
    simc() {
      this.streets = [];
      this.model.$setData({
        street: '',
        [this.field]: ''
      });
      this.checkULICList();
    },
    search(val) {
      if (val) {
        return this.searchULICList(val);
      }
      return this.getAllStreets();
    }
  },
  beforeMount() {
    this.checkULICList();
    this.setULICData();
  },
  methods: {
    // @vuese
    // Zwraca cała listę ulic
    getAllStreets() {
      axios.get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}`).then(res => {
        const apiStreets = res.data.list;
        const overrideStreets = ULIC_OVERRIDE.filter(street => street.applyTo === this.terc);

        this.streets = [...apiStreets, ...overrideStreets];
      });
    },
    // @vuese
    // Sprawdza czy lista ulic nie jest pusta
    checkULICList() {
      if (this.terc && this.simc) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}&count=1`)
          .then(res => {
            const overrideStreetsCount = ULIC_OVERRIDE.filter(street => street.applyTo === this.terc).length;

            if (res.data.list.length === 0 && overrideStreetsCount === 0) {
              this.showSelect = false;
              this.model.$setData({
                street: this.city
              });
            } else {
              this.showSelect = true;
              this.getAllStreets();
            }
          })
          .catch(() => this.notifyError('Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Przeszukje listę ulic
    searchULICList(val) {
      if (this.terc && this.simc) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}&search=${val}`)
          .then(res => {
            const apiStreets = res.data.list;
            const searchLower = val.toLowerCase();
            const overrideStreets = ULIC_OVERRIDE.filter(
              street => street.applyTo === this.terc && street.nameFull.toLowerCase().includes(searchLower)
            );

            this.streets = [...apiStreets, ...overrideStreets];
          })
          .catch(() => this.notifyError('Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Ustawianie pól formularza
    setULICData() {
      this.selectedULIC = this.model[this.field].$value;
      if (this.model.street) {
        this.search = this.model.street.$value;
      } else if (this.selectedULIC) {
        this.findStreetName();
      }
    },
    // @vuese
    // Pobiera nazwę ulicy na podstawie symbolu ulicy
    findStreetName() {
      if (this.simc) {
        const overrideStreet = ULIC_OVERRIDE.find(s => s.symbol === this.model[this.field].$value);
        if (overrideStreet) {
          this.search = overrideStreet.nameFull;
          return;
        }

        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/${this.simc}/${this.model[this.field].$value}`)
          .then(res => (this.search = res.data.list))
          .catch(() => this.notifyError('Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Zapisanie w schema odpowiednich pól po wybraniu ulicy
    changeStreet(val) {
      this.model.$setData({
        street: val ? this.streets.find(item => item.symbol === val).nameFull : '',
        [this.field]: val ? val : ''
      });
    },
    // @vuese
    // Focus na polu
    focus(field) {
      this.model[field].$hasFocus = true;
    },
    // @vuese
    // Blur na polu
    blur(field) {
      this.model[field].$hasFocus = false;
    }
  }
};
</script>
